module.exports = __webpack_public_path__ + "static/media/18_7.42308557.png";